import { IRestaurantNode, useGetRecentRestaurantsQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const useGetRecentRestaurants = () => {
  const { isAuthenticated, user } = useAuthContext();
  const { data, loading, error } = useGetRecentRestaurantsQuery({
    variables: {
      input: {
        first: 20,
      },
    },
    skip: !isAuthenticated || !user?.cognitoId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    restaurants: (data?.recentRestaurants?.nodes as IRestaurantNode[]) || [],
    loading,
    error,
  };
};
